
export interface ByPriceOption {
  OptionId: number;
  DepartureDate: string;
  ArrivalDate: string;
  TotalPrice: number;
  PriceDifference: number;
  CurrencyCode: string;
  IsCurrentDate: boolean;
  DaysDifference: number;
}

export interface ByDate {
  OptionId: number;
  DaysDifferenceMessage: string;
  DaysDifference: number;
  DateRange: string;
  TotalPrice: number;
  PriceDifference: number;
  CurrencyCode: string;
  LengthOfStay: string;
  IsCurrentDate: boolean;
  DepartureDate: string;
  ArrivalDate: string;
}

export interface Slide {
  Active: boolean;
  Title: string;
  SubTitle: string;
  Icon: string;
}

export enum FLEX_CARD_TYPE {
  CHEAPEST_DATES = 'CHEAPEST_DATES',
  SAME_DURATION = 'SAME_DURATION',
  KEEP_DEPARTURE = 'KEEP_DEPARTURE',
  KEEP_ARRIVAL = 'KEEP_ARRIVAL'
}
